<template>
  <div>
    <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>营销运营管理</el-breadcrumb-item>
      <el-breadcrumb-item>合同管理</el-breadcrumb-item>
    </el-breadcrumb> -->

    <el-row :gutter="20">
      <!-- 左侧表单 -->
      <el-col :span="10">
        <el-card>
          <el-row class="title_row">
            <el-col>
              <span class="title_class">合同信息录入</span>
            </el-col>
          </el-row>
          <el-form ref="form" :model="form" label-width="100px">
            <el-form-item label="合同编号">
              <el-input v-model="form.contractNo" placeholder="请输入合同编号"></el-input>
            </el-form-item>
            <el-form-item label="甲方">
              <el-input v-model="form.partyA" placeholder="请输入甲方名称"></el-input>
            </el-form-item>
            <el-form-item label="乙方">
              <el-input v-model="form.partyB" placeholder="请输入乙方名称"></el-input>
            </el-form-item>
            <el-form-item label="合同金额">
              <el-input v-model="form.amount" placeholder="请输入合同金额（万元）" type="number"></el-input>
            </el-form-item>
            <el-form-item label="签订日期">
              <el-date-picker v-model="form.signDate" type="date" placeholder="请选择签订日期" style="width: 100%"></el-date-picker>
            </el-form-item>
            <el-form-item label="合同状态">
              <el-select v-model="form.status" placeholder="请选择合同状态" style="width: 100%">
                <el-option label="草稿" value="0"></el-option>
                <el-option label="已签订" value="1"></el-option>
                <el-option label="执行中" value="2"></el-option>
                <el-option label="已完成" value="3"></el-option>
                <el-option label="已终止" value="4"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注信息"></el-input>
            </el-form-item>
            <div style="text-align: center;">
              <el-button type="primary" @click="onSubmit">提交</el-button>
              <el-button @click="onReset">重置</el-button>
            </div>
          </el-form>
        </el-card>
      </el-col>

      <!-- 右侧 -->
      <el-col :span="14">
        <!-- 合同概览 -->
        <el-card>
          <el-row class="title_row">
            <el-col>
              <span class="title_class">合同概览</span>
            </el-col>
          </el-row>
          <el-row :gutter="30">
            <el-col :span="8" v-for="(item, i) of contractOverviewList" v-bind:key="i">
              <div class="processed-list-con">
                <div class="processed-image" :class="'coloricon' + (i+2)">
                  <i class="icon iconfont icon-yiwancheng"></i>
                </div>
                <div class="processed-count">
                  <div class="processed-desc">{{ item.number }}</div>
                  <div class="processed-title">{{ item.title }}</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-card>

        <!-- 合同列表 -->
        <el-card style="margin-top: 15px">
          <el-row class="title_row">
            <el-col>
              <span class="title_class">审批中合同</span>
            </el-col>
          </el-row>
          <el-table :data="contractList" style="width: 100%" size="small">
            <el-table-column prop="contractNo" label="合同编号" min-width="120"></el-table-column>
            <el-table-column prop="partyA" label="客户" min-width="140"></el-table-column>
            <!-- <el-table-column prop="partyB" label="乙方" min-width="140"></el-table-column> -->
            <el-table-column prop="amount" label="金额（万元）" min-width="100" align="right"></el-table-column>
            <el-table-column prop="statusLabel" label="状态" min-width="80" align="center">
              <template slot-scope="scope">
                <el-tag size="small" effect="plain" :type="getStatusType(scope.row.status)">{{ scope.row.statusLabel }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="80" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="onView(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <!-- 菜单卡片区域 -->
    <el-row :gutter="30">
      <el-col
        v-for="(item, i) in toolList"
        :key="i"
        :span="6"
        style="margin-top: 30px"
      >
        <div class="racing-tool-back" @click="toolClicked(item)">
          <div class="racing-tool-leftimg" :class="'coloricon' + item.menuTag">
            <i class="icon iconfont" :class="item.icon"></i>
          </div>
          <div class="racing-tool-right">
            <div>{{ item.rightTitle }}</div>
            <div class="racing-tool-desc">{{ item.rightDesc }}</div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'contractManagementHome',
  data () {
    return {
      toolList: [],
      form: {
        contractNo: '',
        partyA: '',
        partyB: '',
        amount: '',
        signDate: '',
        status: '',
        remark: ''
      },
      contractOverviewList: [
        { title: '合同总量', number: 50 },
        { title: '审批中', number: 18 },
        { title: '已完成', number: 30 }
      ],
      contractList: [
        { contractNo: 'HT-2026-001', partyA: '北京市海淀区中关村第一小学', partyB: 'SPBCN组委会', amount: 30, status: '2', statusLabel: '审批中' },
        { contractNo: 'HT-2026-002', partyA: '北京师范大学附属实验中学', partyB: 'SPBCN组委会', amount: 50, status: '2', statusLabel: '审批中' },
        { contractNo: 'HT-2026-003', partyA: '上海外国语大学附属浦东外国语学校', partyB: 'SPBCN组委会', amount: 20, status: '2', statusLabel: '审批中' }
      ]
    }
  },
  methods: {
    toolClicked (item) {
      if (!item.turnUrl) return
      this.$router.push(item.turnUrl)
    },
    onSubmit () {
      console.log('提交合同信息:', this.form)
      this.$message.success('提交成功')
    },
    onReset () {
      this.$refs.form.resetFields()
    },
    onView (row) {
      this.$message.info('查看合同：' + row.contractNo)
    },
    getStatusType (status) {
      const map = { 0: '', 1: 'success', 2: 'warning', 3: 'success', 4: 'danger' }
      return map[status] || ''
    }
  }
}
</script>

<style lang="less" scoped>
/* 合同列表 */
.contract-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 10px;
  border-bottom: 1px solid #ebeef5;
  &:last-child {
    border-bottom: none;
  }
  .contract-info {
    flex: 1;
    .contract-no {
      font-size: 14px;
      font-weight: bold;
      color: #303133;
      margin-bottom: 4px;
    }
    .contract-parties {
      font-size: 12px;
      color: #909399;
    }
  }
}
</style>
